import React, { useState } from 'react';
import { Card, Text, Group, Button, Box, Loader, Alert } from '@mantine/core';
import { IconEye, IconFileText } from '@tabler/icons-react';
import { viewDocument } from '../services/storageService';

const DocumentCard = ({ documentKey, title, description }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleView = async () => {
    setLoading(true);
    setError(null);
    try {
      await viewDocument(documentKey);
    } catch (err) {
      setError('Failed to open document. Please try again.');
      console.error('View error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      shadow="md"
      padding="lg"
      radius="lg"
      withBorder
      style={{
        background: 'linear-gradient(145deg, var(--cream) 0%, var(--linen) 100%)',
        border: '2px solid var(--saffron-medium)',
        boxShadow: '0 8px 24px rgba(244, 196, 48, 0.15)',
        transition: 'all 0.3s ease',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header with Icon */}
      <Group mb="md" align="center">
        <Box
          style={{
            backgroundColor: 'var(--saffron-bright)',
            borderRadius: '12px',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <IconFileText size={24} color="white" />
        </Box>
        <Text
          size="lg"
          fw={700}
          style={{
            color: 'var(--charcoal)',
            fontFamily: 'Georgia, serif'
          }}
        >
          {title}
        </Text>
      </Group>

      {/* Description */}
      <Text
        size="sm"
        style={{
          color: 'var(--charcoal)',
          lineHeight: 1.6,
          flex: 1,
          marginBottom: '1rem'
        }}
      >
        {description}
      </Text>

      {/* Error Alert */}
      {error && (
        <Alert color="red" size="sm" mb="md">
          {error}
        </Alert>
      )}

      {/* Action Buttons */}
      <Group gap="xs" mt="auto" justify="center">
        <Button
          leftSection={<IconEye size={16} />}
          size="sm"
          onClick={handleView}
          disabled={loading}
          style={{
            background: 'linear-gradient(135deg, var(--saffron-bright), var(--terracotta-light))',
            color: 'white',
            border: 'none',
            minWidth: '120px'
          }}
        >
          {loading ? <Loader size="xs" /> : 'View'}
        </Button>
      </Group>
    </Card>
  );
};

export default DocumentCard;
